import { render } from "./MangeUsers.vue?vue&type=template&id=e0980dae"
import script from "./MangeUsers.vue?vue&type=script&lang=js"
export * from "./MangeUsers.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__